/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Lastname1Inputs */

const en_settings_lastname1 = /** @type {(inputs: Settings_Lastname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last name`)
};

/**
* | output |
* | --- |
* | "Last name" |
*
* @param {Settings_Lastname1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_lastname1 = /** @type {((inputs?: Settings_Lastname1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Lastname1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_lastname1(inputs)
});
export { settings_lastname1 as "settings_lastName" }